<section
  class="account-onboarding container-box dropdown-shadow p-4 position-relative d-flex flex-column gap-3"
  [class.bg-default2]="isExpanded"
  [style.background-image]="isComplete ? 'linear-gradient(180deg, #EFF9FF 0%, #FFFFFF 100%)' : ''"
  [style.minHeight.px]="isExpanded ? 450 : null"
>
  <button
    class="btn btn-secondary-light position-absolute"
    style="right: 10px; top: 10px"
    *ngIf="!isComplete"
    (click)="isExpanded = !isExpanded"
  >
    <i class="cs-icon" [ngClass]="isExpanded ? 'cs-icon-collapse' : 'cs-icon-expand'"></i>
  </button>
  <button
    class="btn btn-secondary-light position-absolute"
    style="right: 10px; top: 10px"
    *ngIf="isComplete"
    (click)="onDismiss()"
  >
    <i class="cs-icon cs-icon-times"></i>
  </button>

  <ng-container *ngIf="!isComplete">
    <div class="d-flex align-items-center gap-2">
      <div class="icon">
        <img [src]="selectedSection.icon" [alt]="selectedSection.title" width="36" height="36" />
      </div>
      <div class="info flex-fill">
        <div class="text-light text-sm" i18n>Quick-start guide</div>
        <div class="label text-bold">{{ selectedSection.title }}</div>
      </div>
    </div>
    <div class="pl-5 flex-fill" *ngIf="isExpanded">
      <ngb-accordion #taskAccordion="ngbAccordion" class="task-accordion" [closeOthers]="true">
        <ngb-panel
          *ngFor="let task of selectedSection.tasks; trackBy: trackByTask"
          [id]="task.id"
          [cardClass]="'task-panel ' + (task.completed ? 'completed' : '')"
          [disabled]="!isPretaskCompleted(task)"
        >
          <ng-template ngbPanelHeader let-opened="opened">
            <div
              class="task-header d-flex align-items-center clickable"
              (click)="taskAccordion.toggle(task.id)"
              [matTooltip]="task.disabledTooltip"
              [matTooltipDisabled]="isPretaskCompleted(task)"
            >
              <div class="indicator" [class.checked]="isPretaskCompleted(task) && task.completed">
                <span class="text-sm d-inline-flex" *ngIf="isPretaskCompleted(task) && task.completed">
                  <i class="cs-icon cs-icon-check2"></i>
                </span>
                <span class="text-sm d-inline-flex" *ngIf="!isPretaskCompleted(task)">
                  <i class="far fa-lock"></i>
                </span>
              </div>
              <div class="content">
                <div class="text-lg text-semi-bold">{{ task.title }}</div>
              </div>
              <div class="ml-auto">
                <i class="fas fa-chevron-down" *ngIf="!opened"></i>
                <i class="fas fa-chevron-up" *ngIf="opened"></i>
              </div>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="description" *ngIf="task.description; else defaultTaskCopy">{{ task.description }}</p>
            <ng-template #defaultTaskCopy>
              <p class="description" i18n>Complete this step to continue optimizing your account.</p>
            </ng-template>
            <div class="task-actions d-flex align-items-center gap-3">
              <button type="button" class="btn btn-info" (click)="onCompleteTask(task)">
                <i [class]="task.ctaIcon" *ngIf="task.ctaIcon"></i>
                <img [src]="task.ctaIconImage" alt="" height="13" *ngIf="task.ctaIconImage" />
                <ng-container i18n>{{ task.ctaText }}</ng-container>
              </button>
              <button type="button" class="btn btn-light" (click)="onSkipTask(task)" *ngIf="!task.noSkip">
                <ng-container i18n>Skip</ng-container>
              </button>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
    <div class="pl-5" [ngClass]="isExpanded ? 'd-flex align-items-center gap-1' : ''">
      <ngb-progressbar
        type="success"
        [animated]="true"
        [value]="overallProgress"
        class="shadow-none flex-fill"
        style="height: 12px"
      ></ngb-progressbar>
      <div class="text-light text-sm text-right">
        {{ totalCompleted }}/{{ totalSteps }}
        <ng-container i18n>Completed</ng-container>
      </div>
    </div>
  </ng-container>
  <div class="d-flex flex-column align-items-center justify-content-center gap-3 p-5" *ngIf="isComplete">
    <img src="/assets/images/onboarding/done.svg" />
    <h6 class="mb-0 mt-2" i18n>Quick Start Complete!</h6>
    <div class="text-light text-sm" i18n>
      You’re all set — your property management is now faster, easier, and fully optimized.
    </div>
    <button
      class="btn btn-info"
      *ngIf="!(isSubscribed$ | async)"
      (click)="onSubscribe()"
      style="text-transform: initial"
    >
      I’m ready to subscribe
    </button>
  </div>
  <div class="d-flex align-items-center gap-3 pl-5" *ngIf="!isComplete">
    <a href="javascript:void(0)" class="text-semi-bold" (click)="onDismiss()" i18n>Dismiss</a>
    <div class="flex-fill"></div>
    <ng-container *ngIf="isExpanded">
      <button class="btn btn-outline-light btn-sm" (click)="onPrevious()" [disabled]="currentSection === 0" i18n>
        <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
      </button>
      <button
        class="btn btn-outline-light btn-sm"
        (click)="onNext()"
        [disabled]="currentSection === totalSections - 1"
        i18n
      >
        <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
      </button>
    </ng-container>
  </div>
</section>
